import { render, staticRenderFns } from "./ViewReview.vue?vue&type=template&id=090b8f1e&"
import script from "./ViewReview.vue?vue&type=script&lang=js&"
export * from "./ViewReview.vue?vue&type=script&lang=js&"
import style0 from "./ViewReview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports